<template lang="pug">
  .preloader-image__wr.preloader-image__wr--hide
    .preloader-image
      .preloader-image__loaded-wr
        .preloader-image__loaded
</template>

<script>
  import '@/components/common/preloaderImage/preloaderImage.styl';

  import EventBus from '@/eventBus';

  export default {
    name: 'PreloaderImage',

    components: {},

    data() {
      return {}
    },

    created() {
      EventBus.$on('preloaderShow', params => {
        this.$nextTick(() => {
          this.preloader('show', params);
        });
      });

      EventBus.$on('preloaderHide', params => {
        this.$nextTick(() => {
          this.preloader('hide', params);
        });
      });
    },

    methods: {
      preloader(action, page) {
        let $preloader = $('.page__item[data-id="' + page + '"]').find('.preloader-image__wr');

        if(page == 'delivery-address') {
          $preloader = $('.page__item[data-id="cart"]').find('.delivery-address').find('.preloader-image__wr');
        } else if(page == 'popup') {
          $preloader = $('.popup-product').find('.preloader-image__wr');
        }

        if(action === 'show') {
          $preloader.removeClass('preloader-image__wr--hide');

          setTimeout(() => {
            $preloader.addClass('preloader-image__wr--start');
          }, 500);
        }

        if(action === 'hide') {
          $preloader.addClass('preloader-image__wr--end');

          setTimeout(() => {
            $preloader.addClass('preloader-image__wr--hide');

            setTimeout(() => {
              $preloader.removeClass('preloader-image__wr--start preloader-image__wr--end');
            }, 500);
          }, 500);
        }
      }
    }
  }
</script>
